import React, { useMemo } from "react";
import { useViewport } from 'components/general/useViewPort'
import Label from "components/general/Label"
import { findArray } from 'helpers/utils'
import { ColumnName, ColumnNoc } from "components/common/TableColumns"
import MirsTable from "components/general/table/Table";
import Movement from "components/presentation/Movement"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowDown, faArrowUp } from "@fortawesome/free-solid-svg-icons";
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";

export function getColumns() {

    return (
        [
            {
                Header: <Label data={'HeaderSortOrder'} />,
                disableSortBy: true,
                className: 'd-none d-sm-table-cell',
                headerClassName: 'd-none d-sm-table-cell w-5',
                id: 'SortOrder',
                accessor: (props) => {
                    let mainResult = props?.extendedResultsCurrent?.find(er => er?.er_type === 'FAKE' && er?.er_code === 'MAIN_RESULT')?.er_value;
                    mainResult = mainResult ? JSON.parse(mainResult) : {};
                    let value = mainResult?.sortOrder
                    return value
                }
            },
            {
                id: 'Move',
                Header: () => (<><FontAwesomeIcon icon={faArrowUp} /> <FontAwesomeIcon icon={faArrowDown} /></>),
                headerClassName: "text-end",
                className: 'text-end w-10',
                isVisible: true,
                accessor: (props) => {
                    const moveCurrent = props?.extendedResultsCurrent && props?.extendedResultsCurrent[0] ? props?.extendedResultsCurrent[0]?.er_move : '0'
                    return (<Movement move={moveCurrent} />)
                }
            },
            ColumnNoc({ disableSort: true }),
            ColumnName({ disableSort: true }),


        ]
    )
}

export function getColumnsXS() {
    return (
        [
            {
                Header: <Label data={'HeaderSortOrder'} />,
                disableSortBy: true,
                className: 'd-none d-sm-table-cell',
                headerClassName: 'd-none d-sm-table-cell w-5',
                id: 'SortOrder',
                accessor: (props) => {
                    let mainResult = props?.extendedResultsCurrent?.find(er => er?.er_type === 'FAKE' && er?.er_code === 'MAIN_RESULT')?.er_value;
                    mainResult = mainResult ? JSON.parse(mainResult) : {};
                    let value = mainResult?.sortOrder
                    return value
                }
            },
            {
                id: 'Move',
                Header: () => (<><FontAwesomeIcon icon={faArrowUp} /> <FontAwesomeIcon icon={faArrowDown} /></>),
                headerClassName: "text-end",
                className: 'text-end w-10',
                isVisible: true,
                accessor: (props) => {
                    const moveCurrent = props?.extendedResultsCurrent && props?.extendedResultsCurrent[0] ? props?.extendedResultsCurrent[0]?.er_move : '0'
                    return (<Movement move={moveCurrent} />)
                }
            },
            ColumnNoc({ disableSort: true }),
            ColumnName({ disableSort: true }),

        ]
    )
}


const LiveNow = ({ data, configEvent }) => {
    const { breakPoint } = useViewport();
    let columns

    if (breakPoint === "xxl" || breakPoint === "xl" || breakPoint === "lg" || breakPoint === "md") {
        columns = getColumns(data.currentSplit)
    } else {
        columns = getColumnsXS()
    }
    const configCurrent = useMemo(() => columns, [data.currentSplit, breakPoint]);
    const { mirs_rsc } = useUrlFriendlyToParameters()


    let erc = data?.results?.items?.find(item => item?.sortOrder === 1)?.extendedResultsCurrent
    let arrive = findArray(erc, { er_type: ['ER'], er_code: ['LIVE'], er_rank: ['1'] }).er_arrive;
    arrive = arrive !== undefined
        ? <><Label data='HeaderUpdates' /> {arrive}<Label data='LabelM' /></>
        : ''

    let arrayCurrents = data.results.items.filter(item => {
        return (Array.isArray(item.extendedResultsCurrent))
    }
    )

    return (
        <>

            {arrayCurrents && arrayCurrents.length > 0 && <div className="row justify-content-center"><div className="col-md-6 ">
                < MirsTable
                    className='table-result'
                    data={arrayCurrents}
                    columns={configCurrent}
                    keyRow='participant-code'
                    caption={<span className="text-dark"><strong><Label data='LabelLiveNow' /></strong></span>}
                    classCaption='currentIndicator'
                    id={`mirs-table-result-${mirs_rsc}`}
                    hiddenColumns={['SortOrder']}
                    initialSortBy={[{ id: 'SortOrder', desc: false }]}
                />
                <div className="col-md-4">{arrive}</div>
            </div>
            </div>}
        </>
    );
}



export default LiveNow;